<template>
  <div
    class="code-verification md:tw-max-w-[420px] tw-w-full tw-flex tw-flex-col tw-items-center tw-pb-8 md:tw-px-0 md:tw-px-0"
  >
    <div class="tw-w-full">
      <button class="hover:tw-bg-transparent" @click="$router.go(-1)">
        <img
          src="https://res.cloudinary.com/djalafcj9/image/upload/v1649664940/getequityV2/Company-dealroom/Back-button_moomg1.svg"
        />
      </button>
    </div>
    <h1
      class="tw-font-bold tw-leading-[133%] tw-tracking-[-0.1px] tw-text-secondary tw-mb-3 tw-text-2xl tw-mt-6"
    >
      Enter your confirmation code
    </h1>
    <p class="tw-text-[#4F5877] tw-leading-[150%] tw-mb-[40px] tw-text-center">
      We sent an email to
      <span class="tw-font-bold tw-text-base tw-text-secondary">{{
        email
      }}</span
      >. Please type it in so we can verify your account
    </p>
    <CodeVerificationForm @verify="verifyAccount" class="tw-w-full" />
    <div class="tw-flex tw-flex-wrap tw-items-center">
      &nbsp;<button class="tw-text-sm tw-text-primary" @click="resendToken">
        Resend code
      </button>
      <!-- &nbsp;
      <p class="tw-text-sm tw-text-gray">or</p>
      &nbsp;
      <router-link
        :to="{ name: 'DataCollection', params: { type: 'private-raise' } }"
        class="tw-text-sm tw-text-primary"
      >
        change details
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
import CodeVerificationForm from "@/components/onboarding/forms/CodeVerificationForm.vue";
import api from "@/utils/api.js";
import responseHandler from "@/utils/responseHandler.js";
import { getItem, clearStorage } from "@/utils/storage.js";
import { emailUrl } from "@/utils/helpers";

export default {
  name: "CodeVerification",

  components: { OnboardingHeader, OnboardingSubHeader, CodeVerificationForm },

  data() {
    return {
      subHeaderText: "",
      email: "",
    };
  },

  mounted() {
    this.email = getItem("org_details")?.email;

    if (!this.email && !this.$route.query.email) {
      this.showToast({
        description: "Please create an account or sign in",
        display: true,
        type: "error",
      });
      this.$router.push({ name: "SignIn" });
    } else {
      this.showToast({
        description: "Please verify your account",
        display: true,
        type: "info",
        messageTitle: "Enter Token",
      });
    }
  },

  methods: {
    ...mapActions("organisationModule", ["getOrganisationProfile"]),
    ...mapActions("loadingModule", ["verifySuccess", "verifyLoading"]),
    ...mapActions(["showToast"]),
    emailUrl,
    async verifyAccount(payload) {
      this.verifyLoading(true);
      try {
        const response = await api.verifyOrganisation({ token: payload });
        const { data, message, status } = response.data;
        if (status === "success") {
          this.verifySuccess(true);
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          const response = this.getOrganisationProfile(data._id);
          if (response) this.$router.push({ name: "CreatePin" });
          if (!response) {
            // clearStorage();
            this.$router.push({ name: "SignIn" });
          }
          this.verifyLoading(false);
        }
      } catch (error) {
        responseHandler.handleError(error);
        this.verifyLoading(false);
      }
    },

    async resendToken() {
      try {
        const url = `${this.emailUrl()}/onboarding/code-verification/${
          getItem("org_details")?.type
        }?email=${this.email}`;
        const response = await api.sendToken({
          email: this.email,
          mail_base_url: url,
        });
        const { message } = response.data;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
      } catch (error) {
        responseHandler.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.code-verification {
  @media (min-width: 768px) {
    width: 440px;
  }
}
</style>
